export const loading = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    isLoadingCircular: true
  },
  getters: {
    isLoadingCircular: state => state.isLoadingCircular
  },
  mutations: {
    setIsLoadingCircular(state, isLoadingCircular) {
      state.isLoadingCircular = isLoadingCircular;
    }
  },
  actions: {
    setIsLoadingCircular({ commit }, setIsLoadingCircular) {
      commit('setIsLoadingCircular', setIsLoadingCircular);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/loading.js